var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAtminline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 54,
  x: 5,
  y: 5,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 16h39.003M38 16v30a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2V16m26 0v28a2 2 0 0 1-2 2h-3m10-30v26a2 2 0 0 1-2 2h-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 34.492c.336.66 1.02 1.13 1.854 1.356.478.13.98.173 1.477.143C29.357 36 31 34.84 31 33.413c0-.715-.41-1.361-1.074-1.83a4.1 4.1 0 0 0-1.297-.591l-2.159-.688a3.5 3.5 0 0 1-1.113-.508c-.57-.402-.923-.957-.923-1.57 0-1.227 1.41-2.222 3.15-2.222.426-.018.858.02 1.268.131.716.194 1.51.73 1.798 1.297M28 26v-2m0 14v-2"
}))));
export default SvgAtminline;